import { IItem, instanceOfIItem } from "./IItem";
import { RelationalActionParameter } from "./RelationalActionParameter";

export interface IPasteApplicable extends IItem {
  isPasteKeyMatch(parameter: RelationalActionParameter): boolean;
  /** stringとbooleanのどちらを格納するかは各itemに任せる */
  applyPastedValue(text: string, isChecked: boolean, richTextAsHtml?: string): void;
  isPasteApplicable(isQuoting: boolean): boolean;
}

export function instanceOfIPasteApplicable(instance: any): instance is IPasteApplicable {
  if (!instance) { return false; }
  return (instance.applyPastedValue !== undefined)
    && (instance.isPasteKeyMatch !== undefined)
    && (instance.isPasteApplicable !== undefined)
    && instanceOfIItem(instance);
}
